export const baseUrl: string = "http://infodatenbank.seam-release.at/api";
export const apiToken: string = "VpR4dZ5qfhwn4o5D28GS2b0ydzEIsvUiTh4GgicrYA7b7AR2YdfdA9YIhOgx";
